/**
 * - Strax: Strax DICOM Image Service response action enum
 */
export const ResponseAction = {
  None: 'None',
  Wait: 'Wait',
};
